import React, { useEffect, useState, useCallback } from "react";
import {
  Table,
  Spinner,
  Form,
  Pagination,
  Button,
  Card,
  Alert,
} from "react-bootstrap";
import Layout from "../../layout/Layout";
import {
  getMakinaData,
  insertMakinaExcelPaste,
} from "../../../api/uretim/makineDataApi";

const DEFAULT_EXCEL_HEADERS = [
  "FORM NO",
  "İŞ EMRİ NO",
  "GÜN",
  "AY",
  "TARİH",
  "VRD",
  "OPERATÖR",
  "MALZEME CİNSİ",
  "KALINLIK",
  "EN1",
  "EN2",
  "BOY",
  "BANT ENİ",
  "BAĞ İÇİ",
  "FİRMA",
  "HEDEF HIZ",

  // Excel formül kolonları - backend bunları ignore edecek
  "HEDEF PAKET DOLUM SÜRESİ",
  "KG/M FORMUL",
  "HEDEF ÜRETİM FORMUL",
  "HIZ FORMUL",
  "TESTERE KIRILMASI",
  "GERÇEKLEŞEN HIZ",
  "PAKET DOLUM SÜRESİ FORMUL",

  // Mamul
  "MAMUL BAĞ ADETİ",
  "MAMUL YARIM BAĞ",
  "MAMUL MİKTARI KG",
  "METRAJ FORMUL",

  // Alternatif
  "ALTERNATİF BAĞ ADETİ",
  "ALTERNATİF YARIM BAĞ",
  "ALTERNATİF KG",
  "ALTERNATİF YÜZDE FORMUL",
  "ALTERNATİF METRAJ FORMUL",

  // Iskarta / toplam formül kolonları
  "ÜRETİM FORMUL",
  "ISKARTA KG",
  "ISKARTA ADET FORMUL",
  "ISKARTA YÜZDE FORMUL",
  "ISKARTA METRAJ FORMUL",
  "TOPLAM ÜRETİM FORMUL",
  "TOPLAM METRAJ FORMUL",
  "KG/M 2 FORMUL",

  // Duruşlar
  "AKÜMÜLASYON",
  "YIĞMA",
  "FORM DURUŞ",
  "KAYNAK",
  "ELEKTRİK KESİNTİSİ",
  "ELEKTRİK ARIZASI",
  "GALVANİZ ÜNİTESİ",
  "KALİBRE TÜRK KAFALARI",
  "YAĞLAMA",
  "RULMAN DEĞİŞİMİ",
  "TESTERE ARIZASI",
  "MAKARA DEĞİŞİMİ",
  "EBAT AYARI",
  "İSTİF",
  "İŞ EMRİ YOK",
  "PERSONEL EKSİKLİĞİ",
  "YÜKLEME YAPILMASI",
  "KALIP DEĞİŞİMİ",
  "TESTERE DEĞİŞİMİ",
  "TOPLANTI EĞİTİM",
  "SERVİS GEÇ GELMESİ",
  "VİNÇ BEKLEME",
  "DİĞER SEBEPLER",
  "YEMEK ÇAY MOLASI",

  // Son formül kolonları
  "DURUŞLAR TOPLAMI FORMUL",
  "FİİLİ ÇALIŞMA SÜRESİ",
  "VERİM FORMUL",
];

function flattenObject(obj, prefix = "") {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    const fullKey = prefix ? `${prefix}.${key}` : key;

    if (value && typeof value === "object" && !Array.isArray(value)) {
      Object.assign(acc, flattenObject(value, fullKey));
    } else {
      acc[fullKey] = value;
    }

    return acc;
  }, {});
}

function hasExcelHeader(text) {
  const firstLine = String(text || "").split(/\r?\n/)[0] || "";
  const upper = firstLine.toLocaleUpperCase("tr-TR");

  return upper.includes("FORM NO") || upper.includes("İŞ EMRİ NO");
}

function buildRawTextForBackend(text) {
  const cleanText = String(text || "").trim();

  if (!cleanText) return "";

  const lines = cleanText
    .split(/\r?\n/)
    .map((line) => line.trimEnd())
    .filter(Boolean);

  if (!lines.length) return "";

  // Kullanıcı Excel başlığını da yapıştırırsa ilk satırı atıyoruz.
  // Çünkü Excel'de tekrar eden başlıklar var ve backend mapping kayıyor.
  const dataLines = hasExcelHeader(cleanText) ? lines.slice(1) : lines;

  return `${DEFAULT_EXCEL_HEADERS.join("\t")}\n${dataLines.join("\n")}`;
}
function MakinaUretimAnaliz() {
  const [data, setData] = useState([]);
  const [makinaFilter, setMakinaFilter] = useState("all");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(100);

  const [pasteText, setPasteText] = useState("");
  const [pasteMakina, setPasteMakina] = useState("1");
  const [pasteLoading, setPasteLoading] = useState(false);
  const [pasteResult, setPasteResult] = useState(null);
  const [pasteError, setPasteError] = useState("");

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const res = await getMakinaData(makinaFilter, page, limit);

      if (res.data?.data) {
        const flattened = res.data.data.map((item) => flattenObject(item));
        setData(flattened);
      }
    } catch (err) {
      console.error("Veri çekme hatası:", err);
    } finally {
      setLoading(false);
    }
  }, [makinaFilter, page, limit]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleExcelPasteCheck = async () => {
    try {
      setPasteLoading(true);
      setPasteError("");
      setPasteResult(null);

      const rawText = buildRawTextForBackend(pasteText);

      if (!rawText) {
        setPasteError("Lütfen Excel satırlarını yapıştırın.");
        return;
      }

      const res = await insertMakinaExcelPaste({
        makinaAdi: Number(pasteMakina),
        dryRun: true,
        rawText,
      });

      setPasteResult(res.data);
    } catch (err) {
      console.error("Excel kontrol hatası:", err);
      setPasteError(
        err?.response?.data?.message ||
          "Excel verisi kontrol edilirken hata oluştu."
      );
    } finally {
      setPasteLoading(false);
    }
  };

  const handleExcelPasteInsert = async () => {
    try {
      setPasteLoading(true);
      setPasteError("");

      const rawText = buildRawTextForBackend(pasteText);

      if (!rawText) {
        setPasteError("Lütfen Excel satırlarını yapıştırın.");
        return;
      }

      const res = await insertMakinaExcelPaste({
        makinaAdi: Number(pasteMakina),
        dryRun: false,
        rawText,
      });

      setPasteResult(res.data);

      await fetchData();
    } catch (err) {
      console.error("Excel kayıt hatası:", err);
      setPasteError(
        err?.response?.data?.message ||
          "Excel verisi kaydedilirken hata oluştu."
      );
    } finally {
      setPasteLoading(false);
    }
  };

  const summary = pasteResult?.data?.summary;

  return (
    <Layout>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h2 className="fw-bold">Makina Üretim Analiz (Tüm Veriler)</h2>

        <Form.Select
          value={makinaFilter}
          onChange={(e) => {
            setMakinaFilter(e.target.value);
            setPage(1);
          }}
          style={{ width: 180 }}
        >
          <option value="all">Tüm Makineler</option>
          <option value="1">Makina 1</option>
          <option value="2">Makina 2</option>
          <option value="3">Makina 3</option>
          <option value="4">Makina 4</option>
        </Form.Select>
      </div>

      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <div className="d-flex align-items-center justify-content-between gap-3 mb-3">
            <div>
              <h5 className="fw-bold mb-1">Excel’den Üretim Verisi Aktar</h5>
              <div className="text-muted small">
                Excel’den veri satırlarını kopyalayıp direkt aşağıya yapıştır.
                Başlık satırı yapıştırmana gerek yok.
              </div>
            </div>

            <Form.Select
              value={pasteMakina}
              onChange={(e) => setPasteMakina(e.target.value)}
              style={{ width: 160 }}
            >
              <option value="1">Makina 1</option>
              <option value="2">Makina 2</option>
              <option value="3">Makina 3</option>
              <option value="4">Makina 4</option>
            </Form.Select>
          </div>

          <Form.Control
            as="textarea"
            rows={6}
            value={pasteText}
            onChange={(e) => {
              setPasteText(e.target.value);
              setPasteResult(null);
              setPasteError("");
            }}
            placeholder={`Excel satırlarını buraya yapıştır. Örnek:\n44644\t759034\t2\tOCAK\t2OCAK\t1\tY.ÖZKAZANCI\tGR\t0,90\t38\t\t7220\t119,0\t169\tSECURAFENCE...`}
            style={{
              fontFamily: "monospace",
              fontSize: 13,
              whiteSpace: "pre",
            }}
          />

          {pasteError && (
            <Alert variant="danger" className="mt-3 mb-0">
              {pasteError}
            </Alert>
          )}

          {summary && (
            <Alert
              variant={summary.insertedRows > 0 ? "success" : "info"}
              className="mt-3 mb-0"
            >
              <div className="fw-bold mb-2">
                {pasteResult?.message || "Excel aktarım sonucu"}
              </div>

              <div className="d-flex flex-wrap gap-3 small">
                <span>Toplam Satır: {summary.totalRows}</span>
                <span>Geçerli: {summary.validRows}</span>
                <span>Hatalı: {summary.invalidRows}</span>
                <span>Excel İçi Tekrar: {summary.localDuplicateRows}</span>
                <span>DB Tekrar: {summary.dbDuplicateRows}</span>
                <span>Kaydedilebilir: {summary.insertableRows}</span>
                <span>Kaydedilen: {summary.insertedRows}</span>
              </div>
            </Alert>
          )}

          {pasteResult?.data?.invalidRows?.length > 0 && (
            <Alert variant="warning" className="mt-3 mb-0">
              <div className="fw-bold mb-2">Hatalı Satırlar</div>

              {pasteResult.data.invalidRows.slice(0, 5).map((item) => (
                <div key={item.rowNumber} className="small">
                  Satır {item.rowNumber}: {item.errors?.join(", ")}
                </div>
              ))}
            </Alert>
          )}

          {pasteResult?.data?.dbDuplicateRows?.length > 0 && (
            <Alert variant="secondary" className="mt-3 mb-0">
              <div className="fw-bold mb-2">Sistemde Zaten Olan Kayıtlar</div>

              {pasteResult.data.dbDuplicateRows.slice(0, 5).map((item) => (
                <div key={item.rowNumber} className="small">
                  Satır {item.rowNumber}: {item.reason}
                </div>
              ))}
            </Alert>
          )}

          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button
              variant="outline-secondary"
              onClick={() => {
                setPasteText("");
                setPasteResult(null);
                setPasteError("");
              }}
              disabled={pasteLoading}
            >
              Temizle
            </Button>

            <Button
              variant="outline-primary"
              onClick={handleExcelPasteCheck}
              disabled={pasteLoading || !pasteText.trim()}
            >
              {pasteLoading ? "Kontrol Ediliyor..." : "Verileri Kontrol Et"}
            </Button>

            <Button
              variant="success"
              onClick={handleExcelPasteInsert}
              disabled={pasteLoading || !pasteText.trim()}
            >
              {pasteLoading ? "Kaydediliyor..." : "Onayla ve Kaydet"}
            </Button>
          </div>
        </Card.Body>
      </Card>

      {loading ? (
        <div className="d-flex justify-content-center mt-5">
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          <div style={{ overflowX: "auto", maxHeight: "70vh" }}>
            <Table bordered hover responsive className="shadow-sm align-middle">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Form No</th>
                  <th>İş Emri No</th>
                  <th>Tarih</th>
                  <th>Vardiya</th>
                  <th>Operatör</th>
                  <th>Makina</th>
                  <th>Malzeme Cinsi</th>
                  <th>Kalınlık (mm)</th>
                  <th>En1</th>
                  <th>En2</th>
                  <th>Boy (mm)</th>
                  <th>Bant Eni (mm)</th>
                  <th>Bağ İçi</th>
                  <th>Firma</th>
                  <th>Hedef Hız</th>
                  <th>Gerçekleşen Hız</th>
                  <th>Testere Kırılması</th>
                  <th>Bağ Adeti</th>
                  <th>Yarım Bağ</th>
                  <th>Mamul Miktarı (KG)</th>
                  <th>Alt. Bağ</th>
                  <th>Alt. Yarım Bağ</th>
                  <th>Alt. Miktar (KG)</th>
                  <th>İskarta (KG)</th>
                  <th>Akümülasyon (dk)</th>
                  <th>Yığ (dk)</th>
                  <th>Form (dk)</th>
                  <th>Kaynak (dk)</th>
                  <th>Elektrik Kesintisi</th>
                  <th>Elektrik Arızası</th>
                  <th>Galvaniz Ünitesi</th>
                  <th>Kalibre+Türk Kafaları</th>
                  <th>Yağlama</th>
                  <th>Rulman Değişimi</th>
                  <th>Testere Arızası</th>
                  <th>Makara Değişimi</th>
                  <th>Ebat Ayarı</th>
                  <th>İstif</th>
                  <th>İş Emri Yok</th>
                  <th>Personel Eksikliği</th>
                  <th>Yükleme</th>
                  <th>Kalıp Değişimi</th>
                  <th>Testere Değişimi</th>
                  <th>Toplantı / Eğitim</th>
                  <th>Servis Geç Gelmesi</th>
                  <th>Vinç Bekleme</th>
                  <th>Diğer Sebepler</th>
                  <th>Yemek / Çay Molası</th>
                  <th>Duruş Toplam (dk)</th>
                  <th>Fiili Çalışma Süresi</th>
                  <th>Rapor Tarihi</th>
                  <th>Üretim (KG)</th>
                  <th>Metraj (m)</th>
                  <th>Alternatif Metraj</th>
                  <th>Toplam Metraj</th>
                  <th>Toplam Üretim (KG)</th>
                  <th>KG/M</th>
                  <th>Hedef Paket Dolum Süresi</th>
                  <th>Gerçekleşen Hız (m/dk)</th>
                  <th>Paket Dolum Süresi</th>
                  <th>Hedef Üretim (KG)</th>
                  <th>Alternatif %</th>
                  <th>İskarta Adet</th>
                  <th>İskarta %</th>
                  <th>İskarta Metraj</th>
                  <th>Verim (%)</th>
                </tr>
              </thead>

              <tbody>
                {data.map((d, i) => (
                  <tr key={d._id || `${d.formNo}-${d.isEmriNo}-${i}`}>
                    <td>{i + 1}</td>
                    <td>{d.formNo}</td>
                    <td>{d.isEmriNo}</td>
                    <td>
                      {d.tarih
                        ? new Date(d.tarih).toLocaleDateString("tr-TR")
                        : "-"}
                    </td>
                    <td>{d.vardiya}</td>
                    <td>{d.operator}</td>
                    <td>{d.makinaAdi}</td>
                    <td>{d.malzemeCinsi}</td>
                    <td>{d.kalinlik}</td>
                    <td>{d.en1}</td>
                    <td>{d.en2}</td>
                    <td>{d.boy}</td>
                    <td>{d.bantEni}</td>
                    <td>{d.bagIci}</td>
                    <td>{d.firma}</td>
                    <td>{d.hedefHiz}</td>
                    <td>{d.gerceklesenHiz}</td>
                    <td>{d.testereKirilmasi ? "Evet" : "Hayır"}</td>
                    <td>{d.bagAdeti}</td>
                    <td>{d.yarimBag}</td>
                    <td>{d.mamulMiktariKg}</td>
                    <td>{d["alternatif.bagAdeti"]}</td>
                    <td>{d["alternatif.yarimBag"]}</td>
                    <td>{d["alternatif.miktarKg"]}</td>
                    <td>{d.iskartaKg}</td>

                    <td>{d["duruslar.akumulasyon"]}</td>
                    <td>{d["duruslar.yig"]}</td>
                    <td>{d["duruslar.form"]}</td>
                    <td>{d["duruslar.kaynak"]}</td>
                    <td>{d["duruslar.elektrikKesintisi"]}</td>
                    <td>{d["duruslar.elektrikArizasi"]}</td>
                    <td>{d["duruslar.galvanizUnitesi"]}</td>
                    <td>{d["duruslar.kalibreTurkKafalari"]}</td>
                    <td>{d["duruslar.yaglama"]}</td>
                    <td>{d["duruslar.rulmanDegisimi"]}</td>
                    <td>{d["duruslar.testereArizasi"]}</td>
                    <td>{d["duruslar.makaraDegisimi"]}</td>
                    <td>{d["duruslar.ebatAyari"]}</td>
                    <td>{d["duruslar.istif"]}</td>
                    <td>{d["duruslar.isEmriYok"]}</td>
                    <td>{d["duruslar.personelEksikligi"]}</td>
                    <td>{d["duruslar.yuklemeYapilmasi"]}</td>
                    <td>{d["duruslar.kalipDegisimi"]}</td>
                    <td>{d["duruslar.testereDegisimi"]}</td>
                    <td>{d["duruslar.toplantiEgitim"]}</td>
                    <td>{d["duruslar.servisGecGelmesi"]}</td>
                    <td>{d["duruslar.vincBekleme"]}</td>
                    <td>{d["duruslar.digerSebepler"]}</td>
                    <td>{d["duruslar.yemekCayMolasi"]}</td>

                    <td>{d["analiz.duruslarToplami"]}</td>
                    <td>{d.fiiliCalismaSuresi}</td>
                    <td>
                      {d.raporTarihi
                        ? new Date(d.raporTarihi).toLocaleDateString("tr-TR")
                        : "-"}
                    </td>

                    <td>{d["analiz.uretim"]?.toLocaleString()}</td>
                    <td>{d["analiz.metraj"]?.toLocaleString()}</td>
                    <td>{d["analiz.alternatifMetraj"]?.toLocaleString()}</td>
                    <td>{d["analiz.toplamMetraj"]?.toLocaleString()}</td>
                    <td>{d["analiz.toplamUretim"]?.toLocaleString()}</td>
                    <td>{d["analiz.kgMetre"]?.toFixed(3)}</td>
                    <td>{d["analiz.hedefPaketDolumSuresi"]?.toFixed(2)}</td>
                    <td>{d["analiz.gerceklesenHiz"]?.toFixed(2)}</td>
                    <td>{d["analiz.paketDolumSuresi"]?.toFixed(2)}</td>
                    <td>{d["analiz.hedefUretim"]?.toFixed(2)}</td>
                    <td>
                      {d["analiz.alternatifYuzde"] !== undefined
                        ? `${(d["analiz.alternatifYuzde"] * 100).toFixed(2)}%`
                        : "-"}
                    </td>
                    <td>{d["analiz.iskartaAdet"]?.toFixed(2)}</td>
                    <td>
                      {d["analiz.iskartaYuzde"] !== undefined
                        ? `${(d["analiz.iskartaYuzde"] * 100).toFixed(3)}%`
                        : "-"}
                    </td>
                    <td>{d["analiz.iskartaMetraj"]?.toFixed(2)}</td>
                    <td
                      className={
                        d["analiz.verimYuzde"] >= 95
                          ? "text-success fw-bold"
                          : d["analiz.verimYuzde"] >= 80
                            ? "text-warning fw-bold"
                            : "text-danger fw-bold"
                      }
                    >
                      {d["analiz.verimYuzde"]?.toFixed(2)}%
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <small className="text-muted">
              Toplam {data.length} kayıt görüntüleniyor
            </small>

            <Pagination>
              <Pagination.Prev
                disabled={page === 1}
                onClick={() => setPage((p) => Math.max(1, p - 1))}
              />

              <Pagination.Item active>{page}</Pagination.Item>

              <Pagination.Next onClick={() => setPage((p) => p + 1)} />
            </Pagination>
          </div>
        </>
      )}
    </Layout>
  );
}

export default MakinaUretimAnaliz;
